module.exports = __webpack_public_path__ + "static/media/Паспорт GALAD Вега LED.1c0edecf.pdf";